/* eslint-disable no-undef */
import React from 'react';
import { Flex, Button, Heading, Image } from 'rebass';
import closeIcon from 'assets/icons/close.png';
import styled from 'styled-components';
import ErrorMessage from 'components/ErrorMessage';
import Form from 'components/Form';
import Field from 'components/Field';
import { startSearchByLocationSubmit, resolveSearchByLocationSubmit } from './actions';
import ModalContent from '../ModalContent';

const FormButton = styled(Button)`
  width: 150px;
  font-size: 14px;
  padding-top: 10px;
  padding-bottom: 10px;
`;

const Content = styled(ModalContent)`
  flex-direction: column;
  padding: 35px;
`;

interface ShareLinkModalProps {
  closeModalHandler: VoidFunction;
}

const SearchByLocation: React.FC<ShareLinkModalProps> = ({ closeModalHandler }) => {
  return (
    <Content>
      <Flex width="100%" justifyContent="flex-end" mb={1} onClick={closeModalHandler}>
        <Image src={closeIcon} css="cursor: pointer" />
      </Flex>
      <Heading fontSize="26px" textAlign="center" mb={2}>
        Location Search
      </Heading>
      <Form
        startSubmitAction={startSearchByLocationSubmit().type}
        resolveSubmitAction={resolveSearchByLocationSubmit().type}
      >
        {(formProps: any) => {
          const { submitting, submitErrors } = formProps;
          return (
            <Flex flexDirection="column" alignItems="center">
              {submitErrors && <ErrorMessage>{submitErrors.data.error.message}</ErrorMessage>}
              <Field
                name="country"
                label="Country"
                inputType="select"
                selectOptions={['USA', 'Canada']}
              />
              <Field
                name="state"
                label="Province-State"
                inputType="text"
                placeholder="BC"
                pattern="[A-Z]{2}"
                patternMismatch="Needs to be 2 capital letters"
              />
              <Field label="City" name="city" inputType="text" placeholder="Type here" />
              <FormButton type="submit" variant={submitting ? 'disabled' : 'primary'} mt={2}>
                Search
              </FormButton>
            </Flex>
          );
        }}
      </Form>
    </Content>
  );
};

export default SearchByLocation;
